import { render, staticRenderFns } from "./pigTable.vue?vue&type=template&id=e63d8fb8&scoped=true"
import script from "./pigTable.vue?vue&type=script&lang=js"
export * from "./pigTable.vue?vue&type=script&lang=js"
import style0 from "./pigTable.vue?vue&type=style&index=0&id=e63d8fb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63d8fb8",
  null
  
)

export default component.exports